import React from "react";
import { Box, Heading, Text, Image, Stack, Link, Flex } from "@chakra-ui/react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "api/contentful/options";

interface Props {
  videoLink?: any;
  videoTitle?: any;
  videoDescription?: any;
  videoImage?: any;
}

const LargeVideoCard: React.FC<Props> = ({videoLink, videoTitle, videoDescription, videoImage}: Props) => {
  const getVideoLink = (): void => {
    window.open(videoLink);
  };

  return (      
    <Box
      bg="gray.800"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
      borderRadius="15px"
      position="relative"
      w="100%"
    >
      <Flex direction="row" p={4}>
        <Box
          as='button'
          onClick={getVideoLink}
        >
          <Image
            src={videoImage}
            h="150px"
            width="129px"
          />
        </Box>
        <Stack direction="column" pl={4}>
          <Heading size="md" mb={4}>
            <Link onClick={getVideoLink}>
              {videoTitle}
            </Link>
          </Heading>
          <Text>
            {videoDescription && documentToReactComponents(videoDescription, options)}
          </Text>
        </Stack>
      </Flex>
    </Box>
  );
};

export default LargeVideoCard;
